module.exports = __webpack_public_path__ + "img/allow-map1.87956c27.png";